import { useSelector } from 'react-redux';

import RootState from 'types/state/RootState';

const useDocumentLanguage = (): string => {
    return useSelector((state: RootState): string => state.documentLanguage);
};

export default useDocumentLanguage;
